<template>
  <v-container fluid>
    <v-layout class="mb-3">
      <v-flex>
        <h3 class="headline mt-0">{{ selectedBot.type === 'nt' ? 'Reason' : $t('Wrap Up') }}</h3>
      </v-flex>
      <v-flex shrink>
        <v-btn color="primary" :loading="loading" @click="showAdd = true">
          <v-icon class="mr-1">add</v-icon> {{ $t('Add') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-end class="my-3">
      <v-pagination
        v-model="pageNumber"
        :length="pageCount"
        @input="handleChangePage"
      ></v-pagination>
    </v-layout>
    <div v-if="loading" class="text-xs-center py-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-else-if="wrapUps.length == 0">
      <div class="text-xs-center pt-5" style="font-size: 25px">
        <em style="font-size: 50px" class="far fa-folder-open" />
        <br />
        {{ $t('no_data') }}
      </div>
    </template>
    <template v-else>
      <template v-for="(wrapUp, index) in wrapUps">
        <WrapUpItem
          :key="wrapUp.id"
          :wrap-up="wrapUp"
          @updateWrapUp="handleUpdateWrapUp(index, $event)"
          @deleteWrapUp="getWrapUp()"
        ></WrapUpItem>
      </template>
    </template>
    <v-layout row wrap justify-end class="my-3">
      <v-pagination
        v-model="pageNumber"
        :length="pageCount"
        @input="handleChangePage"
      ></v-pagination>
    </v-layout>
    <v-dialog v-model="showAdd" max-width="600px" persistent>
      <WrapUpParentManage
        v-if="showAdd"
        @onClose="showAdd = false"
        @onSave="handleAddWrapUp"
      ></WrapUpParentManage>
    </v-dialog>
  </v-container>
</template>

<script>
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
import WrapUpItem from './WrapUpItem'
import { convertWrapUpRoute } from '@/utils/wrapUp'
import WrapUpParentManage from './WrapUpParentManage'
export default {
  name: 'WrapUpView',
  components: { WrapUpItem, WrapUpParentManage },
  provide() {
    return {
      $validator: this.$validator
    }
  },
  data() {
    return {
      loading: true,
      pageNumber: 1,
      limit: 10,
      total: 0,
      filter: {
        wrap_up: '',
        wrap_up_route: ''
      },
      wrapUps: [],
      showAdd: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageCount() {
      return Math.ceil(this.total / this.limit)
    }
  },
  mounted() {
    this.getWrapUp()
  },
  methods: {
    handleChangePage(page) {
      this.pageNumber = page
      this.getWrapUp()
    },
    async getWrapUp() {
      this.loading = true
      try {
        const response = await this.$store.dispatch('loadWrapUp', {
          page_id: this.selectedBot.pageid,
          limit: this.limit,
          offset: (this.pageNumber - 1) * this.limit,
          ...this.filter
        })
        if (response) {
          this.wrapUps = response.data
            ? response.data.map((wrapUp) => {
                return {
                  ...wrapUp,
                  wrap_up_route: convertWrapUpRoute(wrapUp.wrap_up_route)
                }
              })
            : []
          this.total = +response.total || 0
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.loading = false
      }
    },
    async handleUpdateWrapUp(index, wrapUp) {
      this.$set(this.wrapUps, index, wrapUp)
    },
    async handleAddWrapUp() {
      this.showAdd = false
      this.getWrapUp()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/WrapUp/index.vue